var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2543 35.5207C69.2543 54.6447 53.7512 70.1478 34.6271 70.1478C15.5031 70.1478 0 54.6447 0 35.5207C0 16.3967 15.5031 0.893555 34.6271 0.893555C53.7512 0.893555 69.2543 16.3967 69.2543 35.5207Z",
    fill: "#4B5158"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6271 66.9094C51.9626 66.9094 66.0158 52.8562 66.0158 35.5207C66.0158 18.1852 51.9626 4.13199 34.6271 4.13199C17.2916 4.13199 3.23843 18.1852 3.23843 35.5207C3.23843 52.8562 17.2916 66.9094 34.6271 66.9094ZM34.6271 70.1478C53.7512 70.1478 69.2543 54.6447 69.2543 35.5207C69.2543 16.3967 53.7512 0.893555 34.6271 0.893555C15.5031 0.893555 0 16.3967 0 35.5207C0 54.6447 15.5031 70.1478 34.6271 70.1478Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5441_6084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3382 12.4365L25.0747 26.5598L20.7764 47.4376L35.3382 56.2976L49.9001 47.4376L45.514 26.4721L35.3382 12.4365ZM23.1449 46.4727L26.3906 30.595L33.7592 52.9641L23.1449 46.4727ZM27.4432 26.9984L35.3382 16.1209L43.2332 26.9984L35.3382 50.8588L27.4432 26.9984ZM36.8295 52.9641L44.1982 30.595L47.4439 46.4727L36.8295 52.9641Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5441_6084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.1237,
    height: 43.861,
    fill: "white",
    transform: "translate(20.7764 12.4365)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEos);
export default __webpack_public_path__ + "static/media/eos.8b07155b4a754b89f1457b111a1a75d5.svg";
export { ForwardRef as ReactComponent };